const formatters = {};

function format(countryCode, currency, value) {
  if (!formatters[countryCode]) {
    formatters[countryCode] = {};
  }
  if (!formatters[countryCode][currency]) {
    formatters[countryCode][currency] = new Intl.NumberFormat(countryCode, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return formatters[countryCode][currency].format(value);
}

const CurrencyFormatter = {
  install: function (Vue, options) {
    Vue.prototype.$formatCurrency = function (currency, value) {
      var lang_code = 'en';
      if (this.$store.state.countryCode === 'UK') {
        lang_code = 'en-GB';
        console.log(lang_code);
      } else if (this.$store.state.countryCode === 'US') {
        lang_code = 'en-US';
        console.log(lang_code);
      } else if (this.$store.state.countryCode === 'CA') {
        lang_code = 'en-CA';
        console.log(lang_code);
      } else {
        lang_code = this.$store.state.countryCode;
      }
      // TODO: maybe we should pass the official ISO language
      // code around as well?
      return format(lang_code, currency, value);
    };
  },
};

export default CurrencyFormatter;
